module.exports = __webpack_public_path__ + "static/media/biodef_brand_banner.26148f6e.jpg";